import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import JobHeroSection from './components/JobHeroSection';
import HexagonJobsSection from './components/HexagonJobsSection';
import JobApplicationForm from './components/JobApplicationForm';
import SEO from '../../components/SEO';
import { useEffect } from 'react';
import { initSmoothScroll } from '../../utils/smoothScroll';

const PosaoPage = () => {
  const { t } = useTranslation('jobs');

  useEffect(() => {
    initSmoothScroll();
  }, []);
  
  return (
    <>
      <SEO 
        titleKey="jobs.title" 
        descriptionKey="jobs.description" 
        pagePath="job" 
      />

      <div className="min-h-screen" >
        <Header />
        
        <main className="pt-20">
          <div className="container mx-auto px-6 lg:px-8">
            <Breadcrumb />
          </div>
          
          <JobHeroSection />
          <HexagonJobsSection />
          <JobApplicationForm />
        </main>
      </div>
    </>
  );
};

export default PosaoPage;
